// removed by extract-text-webpack-plugin
module.exports = {"link":"_1BNLF","root":"XRHlZ","author":"_1lWDw","itemName":"Te3xI","category":"_7QkWN"};